'use client';

import { FC } from 'react';

import {
  FacebookIcon,
  InstagramIcon,
  TelegramIcon
} from '@/components/ui/Icons/Icons';
import { CONFIG } from '@/config';

import * as S from './SocialLinks.styles';

interface SocialLinksProps {
  gap?: number;
}

const {
  contacts: { facebookLink, instagramLink, telegramLink }
} = CONFIG;

export const SocialLinks: FC<SocialLinksProps> = ({ gap = 20 }) => {
  return (
    <S.Wrapper $gap={gap}>
      <S.IconLink
        aria-label="Link to instagram"
        data-cy="social-link-instagram"
        target="_blank"
        href={instagramLink}
        prefetch={false}
      >
        <InstagramIcon />
      </S.IconLink>
      <S.IconLink
        aria-label="Link to facebook"
        data-cy="social-link-facebook"
        target="_blank"
        href={facebookLink}
        prefetch={false}
      >
        <FacebookIcon />
      </S.IconLink>
      <S.IconLink
        aria-label="Link to telegram"
        data-cy="social-link-telegram"
        target="_blank"
        href={telegramLink}
        prefetch={false}
      >
        <TelegramIcon />
      </S.IconLink>
    </S.Wrapper>
  );
};
